import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VIEW_ALL_TYPES } from '@app/mpp/shared/enum/ingredient-enum';
import { IngredientSearchResult } from '@app/mpp/shared/model/ingredient-search-result';
import { ViewWillEnter } from '@ionic/angular';
import { PlatformEnum } from '@panamax/app-state';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-ingredient-search-modal',
  templateUrl: './ingredient-search-modal.component.html',
  styleUrls: ['./ingredient-search-modal.component.scss'],
})
export class IngredientSearchModalComponent implements ViewWillEnter {
  @Input() platform: PlatformEnum;
  @Input() ingredientName: string;
  @Input() recipeSearchResult: Observable<IngredientSearchResult[]>;
  @Input() productSearchResult: Observable<IngredientSearchResult[]>;
  @Input() myListSearchResult: Observable<IngredientSearchResult[]>;
  @Input() searchTimeoutTracker: boolean;
  @Input() showNonUsfFeature: boolean;

  @Output() searchEvent = new EventEmitter<string>();
  @Output() submitEvent = new EventEmitter<IngredientSearchResult>();
  @Output() dismissEvent = new EventEmitter<any>();
  @Output() viewAllProductsEvent = new EventEmitter<string>();

  viewRef = VIEW_ALL_TYPES;
  platformRef = PlatformEnum;
  searchKey = '';
  constructor() {}
  ionViewWillEnter(): void {
    this.searchKey = this.ingredientName;
  }

  onSearch() {
    this.searchEvent.emit(this.searchKey);
  }

  dismiss() {
    this.dismissEvent.emit();
  }

  resetSearch() {
    this.searchKey = '';
    this.searchEvent.emit(this.searchKey);
  }

  selectIngredientToAdd(ingredient: IngredientSearchResult) {
    this.submitEvent.emit(ingredient);
  }

  viewAllRecipeRequest() {}

  viewAllProductsRequest() {
    this.viewAllProductsEvent.emit(this.searchKey);
  }

  viewAllOnListRequest() {}
}
